import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export function KpiCard({ label, value, delta, icon: Icon, testId, tone = "default", onClick }) {
  return (
    <Card
      data-testid={testId}
      onClick={onClick}
      className={cn(
        "border-jigsaw-border shadow-sm transition-shadow hover:shadow-md",
        onClick && "cursor-pointer"
      )}
    >
      <CardContent className="flex min-h-[104px] items-start gap-3 p-4">
        {Icon && (
          <div className={cn("flex h-12 w-12 shrink-0 items-center justify-center rounded-xl", tone === "danger" ? "bg-jigsaw-dangerBg text-jigsaw-danger" : "bg-jigsaw-orange/10 text-jigsaw-orange")}>
            <Icon strokeWidth={1.75} className="h-6 w-6" />
          </div>
        )}
        <div className="min-w-0">
          <p className="text-[13px] font-medium text-jigsaw-navy">{label}</p>
          <p className="mt-1 text-[32px] font-bold leading-none tracking-[-0.02em] text-jigsaw-navy">{value}</p>
          {delta && <p className="mt-1.5 text-[12px] text-jigsaw-muted">{delta}</p>}
        </div>
      </CardContent>
    </Card>
  );
}
